import { useContext } from 'react';

import { TopicsContext } from './index';

export function useSelectorsTopics() {
  const { state } = useContext(TopicsContext);

  return { topicsState: state.topics };
}
